import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../redux/features/languageSlice";
import { useTranslation } from "react-i18next";
import Flag from "react-world-flags";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const currentLang = useSelector((state) => state.language.lang);
  const dropdownRef = useRef(null);

  useEffect(() => {
    import("bootstrap").then((bootstrap) => {
      if (dropdownRef.current) {
        new bootstrap.Dropdown(dropdownRef.current);
      }
    });
  }, []);

  const changeLanguage = (lng) => {
    dispatch(setLanguage(lng));
    i18n.changeLanguage(lng);
  };

  // Map language codes to short labels
  const langLabel = currentLang === "de" ? "DE" : "EN";

  return (
    <div className="dropdown">
      <button
        className="btn dropdown-toggle d-flex align-items-center px-1"
        type="button"
        id="languageDropdown"
        ref={dropdownRef}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{
          color: "var(--secondary-light-color)",
        }}
      >
        <strong>{langLabel}</strong>
      </button>

      <ul
        className="dropdown-menu dropdown-menu-end shadow-sm p-0 mt-3"
        aria-labelledby="languageDropdown"
      >
        <li>
          <button
            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
            onClick={() => changeLanguage("de")}
            style={{ backgroundColor: "white" }}
          >
            <Flag code="DE" style={{ width: "20px", height: "15px" }} />
            <span className="ms-2">Deutschland</span>
          </button>
        </li>
        <li>
          <button
            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
            onClick={() => changeLanguage("en")}
            style={{ backgroundColor: "white" }}
          >
            <Flag code="GB" style={{ width: "20px", height: "15px" }} />
            <span className="ms-2">English</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSwitcher;
